module.exports = __webpack_public_path__ + "media/images/sp-side-ad-8a661393743bd7ac4151f0914ee5bed1.png";